import React, { useState } from 'react';
import { URL } from "../../constants/constant";
import SideBar from "../../components/SideBar/SideBar";
import { MenuItem, Button, Select, FormControl, InputLabel, Snackbar } from "@mui/material";
import "./MISComputation.css";
import axios from 'axios';
import moment from "moment";
import DatePicker from "react-datepicker";

const MISComputation = () => {
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [statusFrom, setStatusFrom] = useState('');
    const [statusTo, setStatusTo] = useState('');
    const [dateFrom, setDateFrom] = useState(new Date() - 7 * 24 * 60 * 60 * 1000);
    const [dateTo, setDateTo] = useState(new Date());

    const loggedInUser = JSON.parse(localStorage.getItem("loggedInUserDetails"));

    const handleComputeMIS = (event) => {
        event.preventDefault();
        const payload = {
            statusFrom: statusFrom,
            statusTo: statusTo,
            dateFrom: moment(dateFrom).format("YYYY-MM-DD"),
            dateTo: moment(dateTo).format("YYYY-MM-DD")
        }
        const response = axios.post(URL.demystify_url + 'fetchMISData', payload)
            .then(response => {
                if (response.status !== 200) {
                    setSnackbarMessage('Unable to Download the MIS report');
                    setSnackbarOpen(true);
                } else {
                    setSnackbarMessage('Download MIS Report started');
                    setSnackbarOpen(true);
                    window.open(response.data.report, '_blank');
                }
            })
            .catch(error => {
                setSnackbarMessage('Error: ' + (JSON.stringify(error.response)));
                setSnackbarOpen(true);
            });
    };

    return (
        <div className='grid-container-mis-computation'>
            <div className='grid-sidebar'>
                <SideBar isTechTeam={loggedInUser.isTechTeam} />
            </div>
            <div className='grid-mis-computation'>
                <div className="mis-computation-title">
                    <h1>MIS Computation</h1>
                </div>
                <form className='mis-computation-subsection' onSubmit={handleComputeMIS}>
                    <div className='mis-computation-div'>
                    <FormControl fullWidth className='mis-computation-field'>
                        <InputLabel>Status From</InputLabel>
                        <Select
                            value={statusFrom}
                            label="Status From"
                            onChange={(e) => setStatusFrom(e.target.value)}
                            required
                        >
                            <MenuItem value="Data Entry Pending">Data Entry Pending</MenuItem>
                            <MenuItem value="Doctor Entry Pending">Doctor Entry Pending</MenuItem>
                            <MenuItem value="QC Pending">QC Pending</MenuItem>
                            <MenuItem value="INCOMPLETE">INCOMPLETE</MenuItem>
                            <MenuItem value="VERIFIED">VERIFIED</MenuItem>
                        </Select>
                    </FormControl>
                    </div>
                    <div className='mis-computation-div'>
                    <FormControl fullWidth className='mis-computation-field'>
                        <InputLabel>Status To</InputLabel>
                        <Select
                            value={statusTo}
                            label="Status To"
                            onChange={(e) => setStatusTo(e.target.value)}
                            required
                        >
                            <MenuItem value="Data Entry Pending">Data Entry Pending</MenuItem>
                            <MenuItem value="Doctor Entry Pending">Doctor Entry Pending</MenuItem>
                            <MenuItem value="QC Pending">QC Pending</MenuItem>
                            <MenuItem value="INCOMPLETE">INCOMPLETE</MenuItem>
                            <MenuItem value="VERIFIED">VERIFIED</MenuItem>
                        </Select>
                    </FormControl>
                    </div>
                    <div className='mis-computation-div'>
                        <DatePicker
                            selected={dateFrom}
                            onChange={(newValue) => {
                                setDateFrom(newValue);
                            }}
                            className="datePicker1"
                        />
                        <span style={{ marginRight: "10px", marginLeft: "-5px" }}>
                            &nbsp;
                            to
                        </span>
                        <DatePicker
                            selected={dateTo}
                            onChange={(newValue) => {

                                setDateTo(newValue);
                            }}
                            className="datePicker2"
                        />
                    </div>
                    <Button type="submit" variant="contained">Submit</Button>
                </form>
                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={3000}
                    onClose={() => setSnackbarOpen(false)}
                    message={snackbarMessage}
                />
            </div>
        </div>
    );
};

export default MISComputation;